import { useEffect, useState } from 'react';
import { get } from '../../../../services/apiController';
import { Modal } from 'react-bootstrap';
import DebitNoteDetail from './DebitNoteDetail';

export default function PreviewModal({ open, onClose, debitNoteId }) {
  const [data, setData] = useState({});

  const loadDebitNote = async () => {
    try {
      const response = await get(`/inv/debit-notes/${debitNoteId}`);
      setData(response.data[0]);
    } catch (error) {
      console.log('error', error);
    }
  };



  useEffect(() => {
    if (debitNoteId) {
      loadDebitNote();
    }
  }, [debitNoteId]);

  return (
    <Modal size="xl" show={open} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>Debit Note Details</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
      </Modal.Header>
      <Modal.Body>
        <DebitNoteDetail data={data} isPrint={false} />
      </Modal.Body>
    </Modal>
  );
}
